// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3h5Lm","label":"styles_label__1IGT2"};